import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useCallback } from 'react';
import { shallowEqual } from 'react-redux';
import { clearRebuyWindow } from '../redux/actions/commonActions';
import { selectMyNumChips, selectMyNumJacks } from '../redux/reducers/selfDataReducer';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { OpenModalContainer } from './openModalContainer';
import { RebuyButton } from './rebuyButton';
function getModalTitle(chipsAreNeeded, jacksAreNeeded) {
    const currencyStrings = [];
    if (chipsAreNeeded) {
        currencyStrings.push('Chips');
    }
    if (jacksAreNeeded) {
        currencyStrings.push('Jacks');
    }
    return `${currencyStrings.join(' and ')} Needed!`;
}
export const RebuyWindowContainer = () => {
    const dispatch = useAppDispatch();
    const rebuyWindow = useAppSelector((state) => state.common.rebuyWindow, shallowEqual);
    const myNumChips = useAppSelector(selectMyNumChips);
    const myNumJacks = useAppSelector(selectMyNumJacks);
    const onClose = useCallback(() => {
        dispatch(clearRebuyWindow());
    }, [dispatch]);
    if (!rebuyWindow) {
        return null;
    }
    if (myNumChips === undefined || myNumJacks === undefined) {
        return null;
    }
    const { numChipsNeeded, numJacksNeeded, allowFreeRebuy, eventMessage } = rebuyWindow;
    const chipsAreNeeded = numChipsNeeded > myNumChips;
    const jacksAreNeeded = numJacksNeeded > myNumJacks;
    if (!chipsAreNeeded && !jacksAreNeeded) {
        return null;
    }
    return (_jsxs(OpenModalContainer, { title: getModalTitle(chipsAreNeeded, jacksAreNeeded), ariaLabel: 'Rebuy Modal', onClose: onClose, children: [_jsxs(DialogContent, { children: [_jsx(DialogContentText, { children: eventMessage }), chipsAreNeeded && (_jsxs(DialogContentText, { children: ["The minimum buy-in is $", numChipsNeeded.toLocaleString(), ". You have $", myNumChips.toLocaleString(), "."] })), jacksAreNeeded && (_jsxs(DialogContentText, { children: ["The minimum buy-in is ", numJacksNeeded.toLocaleString(), " Jacks. You have ", myNumJacks.toLocaleString(), "."] }))] }), _jsx(DialogActions, { children: allowFreeRebuy && _jsx(RebuyButton, { onClicked: onClose }) })] }));
};
